module.exports = __webpack_public_path__ + "idea-consult.4cmeftMG.svg";